import { render, staticRenderFns } from "./FixedPhraseTreeSelector.vue?vue&type=template&id=1ccd0815&scoped=true&"
import script from "./FixedPhraseTreeSelector.vue?vue&type=script&lang=ts&"
export * from "./FixedPhraseTreeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FixedPhraseTreeSelector.vue?vue&type=style&index=0&id=1ccd0815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd0815",
  null
  
)

export default component.exports